/* eslint-disable */
/**
 * Select the current palette type
 * @param {any} state The state management `state`
 * @returns {MuiPaletteType} The current `MuiPaletteType`
 */
const themePaletteTypeSelector = (state) => state.theme.palette.type;

export default themePaletteTypeSelector;
